import AppPopover from "@/components/AppPopover";
import CurrencyValue from "@/components/tableElements/CurrencyValue.vue";
import PercentageValue from "@/components/tableElements/PercentageValue.vue";
import BrandPortfolioParentSpendBar from "@/components/brand_portfolio/BrandPortfolioParentSpendBar.vue";
import LoadingElement from "@/components/shared/LoadingElement.vue";
import BrandPortfolioMixin from "@/mixins/BrandPortfolioMixin.vue";
import BrandPortfolioAggregateMixin from "@/mixins/BrandPortfolioAggregateMixin.vue";
export default {
  name: "BrandPortfolioParentSpendCell",
  components: {
    AppPopover,
    CurrencyValue,
    PercentageValue,
    BrandPortfolioParentSpendBar,
    LoadingElement
  },
  mixins: [BrandPortfolioMixin, BrandPortfolioAggregateMixin],
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    portfolio: {
      type: Object,
      default: {}
    },
    children: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    budgetLineDashArray(children) {
      return this.aggregateForecastStatus(children) == "ALERT" ? "2 4" : "none";
    }
  }
};